import { JSX } from 'react'

import { IconProps } from '../../icon'

const Location: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24.0142 44C18.6475 39.4333 14.6392 35.1917 11.9892 31.275C9.33916 27.3583 8.01416 23.7333 8.01416 20.4C8.01416 15.4 9.62249 11.4167 12.8392 8.45C16.0558 5.48333 19.7808 4 24.0142 4C28.2475 4 31.9725 5.48333 35.1892 8.45C38.4058 11.4167 40.0142 15.4 40.0142 20.4C40.0142 23.7333 38.6892 27.3583 36.0392 31.275C33.3892 35.1917 29.3808 39.4333 24.0142 44Z'
      fill='#EE8207'
    />
    <path
      d='M24.0142 40.05C28.4475 36.0167 31.7225 32.3583 33.8392 29.075C35.9558 25.7917 37.0142 22.9 37.0142 20.4C37.0142 16.4667 35.7558 13.25 33.2392 10.75C30.7225 8.25 27.6475 7 24.0142 7C20.3808 7 17.3058 8.25 14.7892 10.75C12.2725 13.25 11.0142 16.4667 11.0142 20.4C11.0142 22.9 12.0975 25.7917 14.2642 29.075C16.4308 32.3583 19.6808 36.0167 24.0142 40.05ZM24.0142 44C18.6475 39.4333 14.6392 35.1917 11.9892 31.275C9.33916 27.3583 8.01416 23.7333 8.01416 20.4C8.01416 15.4 9.62249 11.4167 12.8392 8.45C16.0558 5.48333 19.7808 4 24.0142 4C28.2475 4 31.9725 5.48333 35.1892 8.45C38.4058 11.4167 40.0142 15.4 40.0142 20.4C40.0142 23.7333 38.6892 27.3583 36.0392 31.275C33.3892 35.1917 29.3808 39.4333 24.0142 44Z'
      fill='white'
    />
    <circle cx='24.0142' cy='19' r='7' fill='white' />
  </svg>
)

export default Location
